import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import FullCalendar, {
  EventClickArg,
  EventContentArg,
} from "@fullcalendar/react"; //listMonth, listWeek, listDay, listYear
import {
  CalendarioReservaEvento,
  ListagemReservaResponse,
} from "core/features/reservas/typings";
import moment from "moment";
import { useRef, useState } from "react";
import colors from "core/resources/theme/colors";
import {
  formatUnidadeBloco,
  getIconForAreaComum,
  getCalendarTagColor,
} from "../../util/helper";
import HeaderTable from "../ReservasTable/components/HeaderTable";
import Calendar from "ui/components/Calendar";
import { useLoading } from "../../../../../../../components/GlobalLoading/index";

interface CalendarioReservaProps {
  reservas?: ListagemReservaResponse[];
  onClick: (reserva: ListagemReservaResponse) => any;
  search: string;
  onSearch: (q?: string) => any;
  onChangeView?: () => any;
  loading?: boolean;
  onChangeDate: (start: string, end: string) => any;
  hideSearch?: boolean;
  hideOptionsView?: boolean;
  dateClick?: (data: string) => any;
}

function CalendarioReserva({
  reservas = [],
  onClick,
  search,
  onSearch,
  onChangeView,
  loading = false,
  onChangeDate,
  hideSearch,
  hideOptionsView,
  dateClick,
}: CalendarioReservaProps) {
  const [localView, setLocalView] = useState("dayGridMonth");
  const calendarRef = useRef<FullCalendar | null>(null);

  const _eventos: CalendarioReservaEvento[] | undefined =
    reservas?.map((reserva) => ({
      ...reserva,
      title:
        localView === "dayGridMonth"
          ? `${reserva.areaComum.nome}`
          : `${reserva.areaComum.nome}, ${
              reserva.nomeMorador
            } - ${formatUnidadeBloco(
              reserva.unidade.numero,
              reserva.unidade.blocoQuadra
            )}`,
      backgroundColor: getCalendarTagColor(reserva.status.id),
      start: moment
        .utc(
          `${moment(reserva.data).format("YYYY-MM-DD")}T${reserva.horaInicio}`
        )
        .toISOString(),
      end: reserva.horaFim
        ? moment
            .utc(
              `${moment(reserva.data).format("YYYY-MM-DD")}T${reserva.horaFim}`
            )
            .toISOString()
        : moment().endOf("day").toISOString(),
    })) || [];

  const getReservaFromClickEvent = ({
    event,
  }: EventClickArg): ListagemReservaResponse => {
    return {
      id: event._def.publicId,
      areaComum: event._def.extendedProps.areaComum,
      data: moment(event.start).format("YYYY-MM-DD"),
      documentoMorador: event._def.extendedProps.documentoMorador,
      nomeMorador: event._def.extendedProps.nomeMorador,
      horaInicio: moment(event.start).format("HH:mm"),
      horaFim: moment(event.end).format("HH:mm"),
      unidade: event._def.extendedProps.unidade,
      status: event._def.extendedProps.status,
      fotoMorador: event._def.extendedProps.fotoMorador,
      nomePessoaConfirmacao: event._def.extendedProps.nomePessoaConfirmacao,
      createdAt: event._def.extendedProps.createdAt,
      eventoId: event._def.extendedProps.eventoId||'',
    };
  };

  const handleEventClick = (event: EventClickArg) => {
    const reserva = getReservaFromClickEvent(event);
    onClick(reserva);
  };

  useLoading(loading);

  return (
    <>
      <Box
        boxShadow={"0 0 16px 3px rgba(0, 0, 0, 0.05)"}
        rounded="16px"
        mb="32px"
        p={2}
        bg={colors.white}
      >
        {!hideSearch ? (
          <Box mb={6}>
            <HeaderTable
              value={search}
              onSearch={onSearch}
              onChangeView={onChangeView}
              view="CALENDARIO"
            />
          </Box>
        ) : null}
        <Calendar
          renderEventContent={renderEventContent}
          ref={calendarRef}
          dateClick={dateClick}
          events={_eventos}
          setLocalView={setLocalView}
          handleEventClick={handleEventClick}
          hideOptionsView={hideOptionsView}
          onChangeDate={onChangeDate}
        />
      </Box>
    </>
  );
}

function renderEventContent(eventInfo: EventContentArg) {
  const _eventProps = eventInfo.event._def
    .extendedProps as ListagemReservaResponse;

  return (
    <Flex
      title={eventInfo.event.title}
      rounded="full"
      px={2}
      color={colors.white}
      bg={eventInfo.event.backgroundColor}
      cursor="pointer"
      _hover={{
        boxShadow: `0 0 0 2px ${colors.primary}`,
        outlineColor: colors.primary,
      }}
      alignItems="center"
      h="28px"
    >
      {getIconForAreaComum(
        _eventProps.areaComum.tipoAreaComum.icone,
        false,
        16,
        colors.white
      )}
      <Text as="h4" color={colors.white}>
        {eventInfo.view.type === "dayGridMonth"
          ? eventInfo.event.title
          : `Reserva de ${_eventProps.areaComum.nome}, ${
              _eventProps.nomeMorador
            } - ${formatUnidadeBloco(
              _eventProps.unidade.numero,
              _eventProps.unidade.blocoQuadra
            )}`}
      </Text>
    </Flex>
  );
}

export default CalendarioReserva;
